/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListAutomationsQueryResponse,
  ListAutomationsQueryParams,
} from '../../types/ListAutomations'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listAutomations } from '../../clients/listAutomations'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listAutomationsQueryKey = (params?: ListAutomationsQueryParams) =>
  [
    { url: '/api/v1/automations/automations/' },
    ...(params ? [params] : []),
  ] as const

export type ListAutomationsQueryKey = ReturnType<typeof listAutomationsQueryKey>

export function listAutomationsQueryOptions(
  params?: ListAutomationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listAutomationsQueryKey(params)
  return queryOptions<
    ListAutomationsQueryResponse,
    ResponseErrorConfig<Error>,
    ListAutomationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listAutomations(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description ViewSet for managing automations.
 * Provides CRUD operations for automations with different serializers
 * for list, detail, and create/update operations.
 * @summary List automations
 * {@link /api/v1/automations/automations/}
 */
export function useListAutomations<
  TData = ListAutomationsQueryResponse,
  TQueryData = ListAutomationsQueryResponse,
  TQueryKey extends QueryKey = ListAutomationsQueryKey,
>(
  params?: ListAutomationsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListAutomationsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listAutomationsQueryKey(params)

  const query = useQuery(
    {
      ...listAutomationsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
